import { useSelector } from 'react-redux'

import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'

export const useGetSenderIds = () => {
  const orgId = useSelector(selectOrgId)
  return esApi.endpoints.getOrgSenderIds.useQuery(
    { orgId: String(orgId) },
    {
      skip: !orgId,
    },
  )
}
